import React from 'react';
import { Card } from '@tq/ui-components';

export type EmptyRecordsCardProps = {
  message: string;
};

export const EmptyDataCard: React.FC<EmptyRecordsCardProps> = ({ message }) => {
  return (
    <>
      <Card p={{ base: 0, md: 6 }} border={0} textAlign='center'>
        {message}
      </Card>
    </>
  );
};
